module.exports = __webpack_public_path__ + "assets/img/1.e39b0b3d.png";